module.exports = __webpack_public_path__ + "static/img/ARADIN3_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARADIN3_1.png
// module id = CGeP
// module chunks = 0